import { ApiService } from "./api.service";
import type { TRequestStatus } from "@/types/request-status";

export interface TRequestStatusCreateData {
  name: string;
  color: string;
  group: TRequestStatus["group"];
  description?: string | null;
}

export interface TRequestStatusUpdateData {
  name?: string;
  color?: string;
  group?: TRequestStatus["group"];
  description?: string | null;
  sequence?: number;
}

export class RequestStatusService extends ApiService {
  async list(slug: string): Promise<TRequestStatus[]> {
    return this.get(`/api/workspaces/${slug}/request-statuses/`);
  }

  async create(slug: string, data: TRequestStatusCreateData): Promise<TRequestStatus> {
    return this.post(`/api/workspaces/${slug}/request-statuses/`, data);
  }

  async update(
    slug: string,
    stateId: string,
    data: TRequestStatusUpdateData,
  ): Promise<TRequestStatus> {
    return this.patch(`/api/workspaces/${slug}/request-statuses/${stateId}/`, data);
  }

  async remove(slug: string, stateId: string): Promise<void> {
    return this.delete(`/api/workspaces/${slug}/request-statuses/${stateId}/`);
  }

  async markDefault(slug: string, stateId: string): Promise<TRequestStatus> {
    return this.post(`/api/workspaces/${slug}/request-statuses/${stateId}/mark-default/`, {});
  }
}
